import {
    Ban,
    Banknote,
    Beer,
    Car,
    ChevronsLeft,
    ChevronsRight,
    ChevronUp,
    DollarSign,
    Files,
    LockKeyhole,
    NotepadText,
    Map,
    MapPin,
    MicVocal,
    Music,
    Music2,
    PartyPopper,
    Pause,
    Percent,
    Play,
    PlusSquare,
    Receipt,
    Settings2,
    ShoppingBasket,
    Smartphone,
    Sparkles,
    StickyNote,
    ThumbsDown,
    ThumbsUp,
    TriangleAlert,
    Verified,
    Wrench
} from "lucide-vue"

export default {
    Ban,
    Banknote,
    Beer,
    Car,
    ChevronsLeft,
    ChevronsRight,
    ChevronUp,
    DollarSign,
    Files,
    LockKeyhole,
    NotepadText,
    Map,
    MapPin,
    MicVocal,
    Music,
    Music2,
    PartyPopper,
    Pause,
    Percent,
    Play,
    PlusSquare,
    Receipt,
    Settings2,
    ShoppingBasket,
    Smartphone,
    Sparkles,
    StickyNote,
    ThumbsDown,
    ThumbsUp,
    TriangleAlert,
    Verified,
    Wrench
}
